import React from 'react';
import ResetPasswordForm from '../forms/ResetPasswordForm/ResetPasswordForm';


const ResetPassword: React.FC = () => {
  return (
    <>
      <ResetPasswordForm />
    </>
  )
}

export default ResetPassword;
